export default __webpack_public_path__ + "static/media/sadge.3d320994.png";